import {createContext} from 'react'

const SolicitudesComprasContext = createContext()

export default SolicitudesComprasContext